<template>
    <Button label="Trocar status" icon="pi pi-sync" v-show="aplicacao" class="ml-2" @click="confirmaAtivarDesativar()" />
</template>

<script>
import AplicacoesServicos from './services';

export default {
    props: {
        aplicacao: {
            type: Object,
        },
    },

    methods: {
        confirmaAtivarDesativar() {
            this.$confirm.require({
                message: `Confirma a ${this.aplicacao.status == 0 ? 'ativação' : 'desativação'} da aplicação ${this.aplicacao.codigo}?`,
                header: `${this.aplicacao.status == 0 ? 'Ativação' : 'Desativação'} da Aplicação`,
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.ativarDesativar();
                },
            });
        },

        ativarDesativar() {
            this.$emit('atualizarErros', []);
            this.$store.dispatch('addRequest');
            AplicacoesServicos.ativarDesativar(this.aplicacao, this.aplicacao.status == 0 ? 'ativar' : 'desativar').then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.add({
                            severity: 'success',
                            summary: 'Aplicação',
                            detail: 'Status da aplicação alterado com sucesso',
                            life: 3000,
                        });
                        this.$emit('atualizarAplicacao', response.data);
                        this.$store.dispatch('setRecarregar', true);
                    } else {
                        this.$emit('atualizarErros', response.errors);
                    }
                }
                this.$store.dispatch('removeRequest');
            });
        },
    },
};
</script>

<style scoped>
.toggleForm {
    font-size: 1.2em;
}
</style>
